export default class FormFields {
    constructor() {
        this.gformInputElements = document.querySelectorAll('.ginput_container input');
        this.gformTextareaElements = document.querySelectorAll('.ginput_container textarea');
        window.addEventListener('load', () => this.init());
    }
    init() {
        if (this.gformInputElements.length > 0) {
            this.initGformInput();
        }
        if (this.gformTextareaElements.length > 0) {
            this.initGformTextarea();
        }
    }
    initGformInput() {
        this.gformInputElements.forEach((input) => {
            input.addEventListener('change', (event) => {
                const currentInput = event.currentTarget;
                const parent = currentInput.parentElement;
                if (currentInput.value.length > 0) {
                    parent.classList.add('active');
                }
                else {
                    parent.classList.remove('active');
                }
            });
        });
    }
    initGformTextarea() {
        this.gformTextareaElements.forEach((textarea) => {
            textarea.addEventListener('change', (event) => {
                const currentTextarea = event.currentTarget;
                const parent = currentTextarea.parentElement;
                if (currentTextarea.value.length > 0) {
                    parent.classList.add('active');
                }
                else {
                    parent.classList.remove('active');
                }
            });
        });
    }
}
